import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Seems I am in love with learning",
  "description": "",
  "published": "2011-09-14T00:00:00.000Z",
  "redirect_from": ["/blog/seems-i-am-in-love-with-learning/swizec/2442"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/300px-Longboard_skateboard3.jpg",
        "alt": "Longboarding",
        "title": "Longboarding"
      }}></img></p>
    <p>{`Today I fell on my arse. Hard. And I have the scrapes and possible bruises to prove it!`}</p>
    <p>{`Apparently going uphill on a longboard is a lot harder than it looks when you've been riding one a cumulative of ... three or four hours. Somehow my trajectory changed from being perpendicular to the hill or the hill changed slopes ... all I know is that at some point my legs were crossed and I was in the air.`}</p>
    <p>{`The result was a very happy swizec with a smile up to his ears. I realized something in that moment --> the reason I fell in love with riding a longboard (I'd say `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Longboarding",
        "title": "Longboarding"
      }}>{`longboarding`}</a>{`, but that implies going down a hill and I'm too pussy to do that) so quickly is that I don't know how to do it!`}</p>
    <p>{`Three days ago I was such a noob at this stuff it took me longer to get home from college than it would on foot. Now it's as quick as rollerblading (on my old skates) and getting faster. A lot faster!`}</p>
    <p>{`Thing is, I sort of jumped into the deep end with this. `}<a parentName="p" {...{
        "href": "http://twitter.com/zidarsk8"
      }}>{`@zidarsk8`}</a>{` just showed me how to stop, I still can't brake, I can only stop. Sort of. The rest I had to figure out on my own and it's this steep learning curve that is the most thrilling thing to me.`}</p>
    <p>{`This is `}{`[`}{`probably] why I change technologies so quickly. This must be why I started the whole being entrepreneurial thing. If it isn't hard, it's boring, and if it's boring I don't want to do it.`}</p>
    <p>{`Jumping into the deep end is `}<em parentName="p">{`fun!`}</em></p>
    <p>{`I wonder if there's a correlation between people who don't enjoy living safely and startup founders ... any idea how to find that out?`}</p>
    <p>{`Also, I'm left wondering why this love for learning isn't translating into a good academic track record O.o`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://srttourteam.wordpress.com/2011/08/05/longboards/"
        }}>{`Longboards`}</a>{` (srttourteam.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://someguynamedben.wordpress.com/2011/07/02/yay-longboard/"
        }}>{`Yay! Longboard`}</a>{` (someguynamedben.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.thestar.com/news/article/1025357--longboarder-hit-by-car-seriously-injured"
        }}>{`Longboarder hit by car, seriously injured`}</a>{` (thestar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://shapeyoursoul.wordpress.com/2011/08/02/find-my-soul/"
        }}>{`Find my Soul`}</a>{` (shapeyoursoul.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fd7c855c-fd36-44a3-8bc9-087a697e7550",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      